import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import {Alert} from '../../components/designSystem';

// redux
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

// i18n
import {withTranslation} from 'react-i18next';

import {uxAnalyticsUtil} from '../../utils';
import './appAlerts.css';

export class AppAlertMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {alert} = this.props;
    uxAnalyticsUtil.trackEvent({
      category: uxAnalyticsUtil.categories.ALERTS,
      action: 'Displayed app alert',
      label: alert._id,
      nonInteraction: true
    });
  }

  onDismiss = (event, data) => {
    const {alert} = this.props;
    uxAnalyticsUtil.trackEvent({
      category: uxAnalyticsUtil.categories.ALERTS,
      action: 'Dismissed app alert',
      label: alert._id
    });
    if (this.props.onDismiss) {
      this.props.onDismiss(alert._id, alert.daysToExpire);
    }
  };

  getLink = action => {
    if (action.path !== undefined) {
      return (
        <Link to={action.path}>
          {action.text}
        </Link>
      );
    }
    // no path, assume regular url
    return (
      <a
        href={action.url}
        target={action.target ? action.target : '_self'}
        rel={action.target === '_blank' ? 'noopener noreferrer' : undefined}>
        {action.text}
      </a>
    );
  };

  render() {
    const {alert} = this.props;
    const variant = alert.color === 'red' ? 'error' :
      ['orange', 'yellow'].includes(alert.color) ? 'warning' :
      alert.color === 'green' ? 'success' : 'info';
    return (
      <Alert variant={variant} className='br-app-alert'>
        <div className='br-app-alert__content'>
          {alert.message}
          {alert.action && this.getLink(alert.action)}
        </div>
        {alert.dismissable && <button type='button' className='br-app-alert__dismiss'
          aria-label='Dismiss alert' onClick={this.onDismiss}>×</button>}
      </Alert>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  idToken: state.user.idToken,
  user: state.user.user,
  userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: newPage => push(newPage)
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AppAlertMessage))
);
